import { render, staticRenderFns } from "./thirdpartyInformationShare.vue?vue&type=template&id=17583424&scoped=true&"
import script from "./thirdpartyInformationShare.vue?vue&type=script&lang=js&"
export * from "./thirdpartyInformationShare.vue?vue&type=script&lang=js&"
import style0 from "./thirdpartyInformationShare.vue?vue&type=style&index=0&id=17583424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17583424",
  null
  
)

export default component.exports